import { getAccessTokenJwtHeader } from '@/assets/src/amplify/helpers';
import { getJson } from '@/assets/src/json_loader';
import { API_URL } from '@/assets/src/configs';
import { getQueryFromSearchParameters } from '@/assets/src/search_parameter';
import { SearchParameter } from '@/assets/src/search_parameter';

const listUsersEndpoint = `${API_URL}/private/users`;
const getUserEndpoint = `${API_URL}/private/user`;
const queryParameterPaginationToken = 'pagination_token';

export interface User {
  cognito_id: string;
  cognito_username: string;
  account_group_id: number;
  account_group_role: string;
  stripe_customer_id?: string;
}

export class UserClient {
  private users: any[] = [];
  private paginationToken: string = '';
  private allUsersFetched: boolean = false;

  public async getUser(cognitoID: string): Promise<User> {
    const headers = await getAccessTokenJwtHeader();
    const endpoint = `${getUserEndpoint}/${cognitoID}`;
    const response: any = await getJson(endpoint, headers);

    return response.user;
  }

  public async findUser(searchParameters: SearchParameter[]): Promise<any[]> {
    const headers = await getAccessTokenJwtHeader();
    const query = getQueryFromSearchParameters(searchParameters);
    const endpoint = listUsersEndpoint + query;
    const response: any = await getJson(endpoint, headers);

    return response.users;
  }

  public async fetchUsers(searchParameters: SearchParameter[]): Promise<any[]> {
    if (this.allUsersFetched) {
      return this.users;
    }

    // Update pagination token
    const idx = searchParameters.findIndex((el) => el.type === queryParameterPaginationToken);
    if (idx > -1) {
      searchParameters[idx].value = this.paginationToken;
    }

    if (idx === -1 && this.paginationToken.length > 0) {
      searchParameters.push(new SearchParameter(queryParameterPaginationToken, this.paginationToken));
    }

    const headers = await getAccessTokenJwtHeader();
    const query = getQueryFromSearchParameters(searchParameters);
    const endpoint = listUsersEndpoint + query;
    const listUsers: any = await getJson(endpoint, headers);

    this.paginationToken = listUsers[queryParameterPaginationToken];
    this.allUsersFetched = listUsers[queryParameterPaginationToken].length === 0;
    this.users = this.users.concat(listUsers.users);

    return this.users;
  }
}
